import Home from "../components/landing/Home";
import About from "../components/landing/About";
import Services from "../components/landing/Services";
import PortfolioPreview from "../components/landing/PortfolioPreview";
import Team from "../components/landing/Team";
import Blog from "../components/landing/Blog";
import Partners from "../components/landing/Partners";
import FAQ from "../components/landing/FAQ";
import Contact from "../components/landing/Contact";

function Landing() {
  return (
    <>
      <Home />
      <About />
      <Services />
      <PortfolioPreview />
      <Team />
      <Blog />
      <Partners />
      <FAQ />
      <Contact />
    </>
  );
}

export default Landing;
